module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-rasa"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("translate")('Breed')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.isValidRasa() || !_vm.isValidVelikost()) && _vm.tryEscape),
      expression: "(!isValidRasa() || !isValidVelikost()) && tryEscape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isValidRasa() && _vm.tryEscape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm._f("translate")('You have to select a breed')))]) : _vm._e(), _vm._v(" "), (!_vm.isValidVelikost() && _vm.tryEscape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm._f("translate")('You have to select a size')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "rasa-krizenec"
  }, [_c('div', {
    staticClass: "form-radios"
  }, _vm._l((_vm.rasaTypItems), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.rasa.typ),
        expression: "mazlicek.rasa.typ"
      }],
      attrs: {
        "type": "radio",
        "id": item.val
      },
      domProps: {
        "value": item.val,
        "checked": _vm._q(_vm.mazlicek.rasa.typ, item.val)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.mazlicek.rasa, "typ", item.val)
        }, function($event) {
          _vm.changeTyp(item.val)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.val
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "rasa-krizenec-vyber",
    class: {
      'has-error': !_vm.isValidRasa() && _vm.tryEscape
    }
  }, [(_vm.mazlicek.rasa.typ === 'app_rasa') ? _c('autocomplete', {
    attrs: {
      "keyword": _vm.mazlicek.rasa.autocomplete.keyword,
      "options": _vm.rasaItems
    },
    on: {
      "select": _vm.rasaSelect
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_velikost') ? _c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isValidVelikost() && _vm.tryEscape
    }
  }, [_c('h2', {
    staticClass: "konf-subtitle"
  }, [_vm._v(_vm._s(_vm._f("translate")('Select the closest')) + ":")]), _vm._v(" "), _vm._l((_vm.velikostItems), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.rasa.velikost),
        expression: "mazlicek.rasa.velikost"
      }],
      attrs: {
        "type": "radio",
        "id": item.id
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.rasa.velikost, item.id)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.mazlicek.rasa, "velikost", item.id)
        }, _vm.changeSizePriceRatio]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e()])])
  })], 2) : _vm._e()], 1)]), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 2
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a93a61","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/02Rasa.vue
// module id = 545
// module chunks = 1